import { prop, isMobile, sleep } from 'Utils/utils'
import { store } from 'Store/store.index';
import { SDK_FINISH_LOAD } from 'Store/constants'
import useWebAssembly from 'Utils/useWebAssembly'
//store.appStore.emitEvent(SDK_FINISH_LOAD)

let latestServiceWorker = null;
let readyState = '';
let swVersion = window.__hashVersion__ ? window.__hashVersion__ : Date.now();
let handle = null;
let postTime = 1000 * 10;

const sendLoadFilesMessage = (worker, isCheckFiles) => {
  store.userStore.reLoadUserApisForServiceWorker();
  worker.postMessage({
    type: 'LOAD_NEW_FILES',
    isCheckFiles,
    version: swVersion,
    lang: store.appStore.lng.full,
    env: store.appStore.environmentName,
    isMobile: isMobile(),
    ...useWebAssembly(),
    fontsHash: window.__sdkFontsHash__
  });
}
function notifyLoadFiles(/* info */) {
  // TODO: remove log, when finish
  //prop(console, 'log')(info);
  if (readyState === SDK_FINISH_LOAD && !latestServiceWorker) {
    sleep(10).then(() => {
      navigator.serviceWorker.ready.then(registration => {
        if (registration.active && !registration.waiting && !latestServiceWorker) {
          sendLoadFilesMessage(registration.active, true)
        }
      });
    })
  }
  if (readyState !== SDK_FINISH_LOAD || !latestServiceWorker) {
    return;
  }
  handle && clearTimeout(handle);
  handle = setTimeout(() => {
    clearTimeout(handle);
    // fix error for auto goto cas
    sendLoadFilesMessage(latestServiceWorker, false)
  }, postTime);
}

// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  prop(location, 'hostname') === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  prop(location, 'hostname') === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  prop(location, 'hostname').match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if (/* process.env.NODE_ENV === 'production' && */ 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, prop(location, 'href'));
    if (publicUrl.origin !== prop(location, 'origin')) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker-online.js?version=${swVersion}`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        //navigator.serviceWorker.ready.then(() => { });
        registerValidSW(swUrl, config);
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
    store.appStore.addAppEventListener(SDK_FINISH_LOAD, () => {
      //
      readyState = SDK_FINISH_LOAD;
      try {
        notifyLoadFiles('loaded sdk');
      } catch (e) {
        //window.location.reload();
        console.log('===>>> registerValidSW ~ store.appStore.addAppEventListener ~ e', e);
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      //store.appStore.outputInfoLog('registerValidSW register registration: ', registration);
      //store.appStore.outputInfoLog('registerValidSW register registration: ', { ...registration }, { installing: !!registration.installing, active: !!registration.active, waiting: !!registration.waiting });

      // 每当 registration.Installing 属性获取新的sw时都会调用该方法
      registration.onupdatefound = () => {
        //store.appStore.outputInfoLog('registration.onupdatefound: ', { installing: !!registration.installing, active: !!registration.active, waiting: !!registration.waiting });
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        latestServiceWorker = installingWorker;
        installingWorker.onstatechange = () => {

          try {
            notifyLoadFiles('worker-state:' + installingWorker.state);
          } catch (e) {
            console.log('===>>> registerValidSW installingWorker onstatechange ~ e', e);
          }
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            prop(location, 'reload')();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.error(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
